import { IAccessToken, useDecodedTokens } from './useDecodedTokens'
import config from '../../../auth0-management-api/src/services/universalTemplate/brandingConfig'
import { FormType, Forms, forms } from '@norstella/nxp-sso-web/utils/Forms'
import { useSearchParams } from 'react-router-dom'

export interface IBrandingPageSection {
  subHeader?: {
    title: string,
    description: string,
  },
  seo?: {
    title: string,
  },
  title?: string,
  description?: string,
  resendEmailBtnText?: string,
}

export interface IAppBrandingConfig {
  name: string,
  themeId: string,
  [key: string]: string | undefined | boolean | object | IBrandingPageSection,
}

export const useBranding = (): [Forms, IAppBrandingConfig] => {
  const [searchParams] = useSearchParams()
  const [tokens] = useDecodedTokens()

  const accessToken = tokens.accessToken as IAccessToken
  const appGroupId = accessToken?.app_group_id || searchParams.get('applicationGroupId')
  const appCode = accessToken?.app_code

  let branding = config.applicationGroups.find(group => group.name === appGroupId)
  let isGeneralBrandingUsed = false

  if (branding && appCode) {
    const appSpecificConfig = config.applicatons?.find(app => app.code === appCode) || {}
    branding = { ...branding, ...appSpecificConfig }
  }

  if (!branding) {
    isGeneralBrandingUsed = true
    branding = config.applicationGroups.find(group => group.name === config.defaultGroupName)
  }

  Object.entries(forms).forEach(([formName, form]) => {
    form.header.bgColor = branding?.logoBackground
    form.header.image = branding?.logoUrl
    form.header.isGeneralBrandingUsed = isGeneralBrandingUsed

    if (formName.includes('verify')) {
      form.footer = branding?.verifyFooter
    }
  })

  forms[FormType.error].footer = branding?.errorFooter
  forms[FormType.federatedSignup].footer = branding?.fedSignupErrorFooter

  const contactForms = [
    FormType.nonBusinessDomain,
    FormType.emailCheckFailed,
  ]

  contactForms.forEach(formType => {
    forms[formType].contacts = branding?.contacts
  })

  return [forms, branding as IAppBrandingConfig]
}
